class GPLightningDeal extends HTMLElement {
  connectedCallback() {
    this.update = this.update.bind(this);
    this.measure = this.measure.bind(this);
    this.observer = new ResizeObserver(this.measure);
    this.observer.observe(this);
    if (this.dataset.previewPlaceholder !== undefined) { this.measure(); return; }
    this.update();
    if (!this.hidden) this.timer = window.setInterval(this.update, 1000);
    document.addEventListener('visibilitychange', this.update);
  }

  measure() {
    const height = this.hidden ? 0 : this.getBoundingClientRect().height;
    document.querySelectorAll('[data-lightning-compact]').forEach((hero) => {
      hero.style.setProperty('--gp-lightning-height', `${height}px`);
    });
  }

  update() {
    const remaining = Math.max(0, Math.ceil(Number(this.dataset.deadline) - Date.now() / 1000));
    if (!Number.isFinite(remaining) || remaining <= 0) {
      this.hidden = true;
      window.clearInterval(this.timer);
      this.measure();
      return;
    }
    const parts = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
    ['hours', 'minutes', 'seconds'].forEach((key, index) => {
      this.querySelector(`[data-${key}]`).textContent = String(parts[index]).padStart(index === 0 ? 1 : 2, '0');
    });
    this.measure();
  }

  disconnectedCallback() {
    this.observer.disconnect();
    window.clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.update);
    document.querySelectorAll('[data-lightning-compact]').forEach((hero) => hero.style.setProperty('--gp-lightning-height', '0px'));
  }
}

if (!customElements.get('gp-lightning-deal')) customElements.define('gp-lightning-deal', GPLightningDeal);
if (!document.querySelector('gp-lightning-deal')) {
  document.querySelectorAll('[data-lightning-compact]').forEach((hero) => hero.style.setProperty('--gp-lightning-height', '0px'));
}
